import { db } from "./db";
import convert from "./convert";

const parse = async (module, payload) => {
    let cloned_payload = JSON.parse(JSON.stringify(payload));

    switch (module) {
        case "documents": // Nieuwe module voor bestanden
            for (const document of cloned_payload) {
                let file_data = await convert.getFileData(document);

                if (file_data) {
                    document.url = file_data;
                    await db.documents.update(document.uuid, document); // Sla het bestand op in Dexie
                }
            }
            break;
        case "inspections":
            for (const inspection of cloned_payload) {
                // if we already have location_uuid, we don't need to run this so we return
                if (inspection.location_uuid) {
                    return cloned_payload;
                }

                // convert images to base64
                // if (inspection.location) {
                //     if (inspection.location.images) {
                //         for (const image of inspection.location.images) {
                //             let image_data = await convert.getImageData(image).catch((error) => {
                //                 console.log(error);
                //             });

                //             if (image_data) {
                //                 image.url = image_data;
                //                 await db.images.update(image.uuid, image);
                //             }
                //         }
                //     }
                // }

                // set correct fields
                inspection.status = inspection.inspection_status?.name;
                inspection.location_uuid = inspection.location?.uuid;
                inspection.location_name = inspection.location?.name;
                inspection.customer_name = inspection.customer?.name;
                inspection.risk_groups = inspection.location?.risk_groups;

                if (inspection.customer?.addresses) {
                    inspection.customer_addresses = inspection.customer.addresses;
                }

                if (inspection.location?.address) {
                    inspection.location_address = inspection.location.address;
                }

                inspection.method_type_name = inspection.inspection_method_type?.name;
                inspection.checklists = inspection.inspection_method_type?.checklists;

                // remove location_items object (sanitation)
                delete inspection.location_items;
                delete inspection.inspection_status;
                delete inspection.location;
                delete inspection.inspection_method_type;
            }
            break;
        case "notifications":
            cloned_payload = Object.values(cloned_payload);
            break;
        case "location_items":
            for (const location_item of cloned_payload) {
                delete location_item.state;
                delete location_item.location_item_components;
            }
            break;
        case "location_item_components":
            for (const location_item_component of cloned_payload) {
                if (location_item_component.component) {
                    location_item_component.parent = location_item_component.component.parent;
                    location_item_component.component_name = location_item_component.component.name;
                }

                // if (location_item_component.images) {
                //     for (const image of location_item_component.images) {
                //         let image_data = await convert.getImageData(image).catch((error) => {
                //             console.log(error);
                //         });

                //         if (image_data) {
                //             image.url = image_data;
                //             await db.images.update(image.uuid, image);
                //         }
                //     }
                // }

                if (location_item_component.component?.forms) {
                    location_item_component.forms = location_item_component.component.forms;
                }

                delete location_item_component.component;
                delete location_item_component.location_item;
                delete location_item_component.measurements;
                delete location_item_component.observations;
                delete location_item_component.documents;
                delete location_item_component.inspection;
            }
            break;
        case "observations":
            for (const observation of cloned_payload) {
                // for (const image of observation.images) {
                //     let image_data = await convert.getImageData(image);

                //     if (image_data) {
                //         image.url = image_data;
                //         await db.images.update(image.uuid, image);
                //     }
                // }

                // sanitize
                delete observation.images;
                delete observation.inspection;
            }
            break;
        case "measurements":
            for (const measurement of cloned_payload) {
                // if (measurement.images) {
                //     for (const image of measurement.images) {
                //         let image_data = await convert.getImageData(image);

                //         if (image_data) {
                //             image.url = image_data;
                //             await db.images.update(image.uuid, image);
                //         }
                //     }
                // }

                // Field rules are now stored as a snapshot in the measurement
                // (no longer stripped) so that field rules travel with the measurement
                // and are not re-resolved from the revision at load time.

                // sanitize
                delete measurement.images;
                delete measurement.inspection;
            }
            break;
        case "location_item_types":
            cloned_payload.sort((a, b) => a.name.localeCompare(b.name));
            break;

        // forms
        case "forms":
            for (const form of cloned_payload) {
                // db.forms is the global form catalog. The inspection link now lives in
                // the forms_inspections junction table (written by the inspection sync),
                // not on the form row, so strip the per-inspection fields. `questions`
                // stay because they are intrinsic to the form definition.
                delete form.pivot;
                delete form.answers;
                delete form.inspection_id;
            }
            break;

        default:
            break;
    }

    return cloned_payload;
};

export default parse;
